import React, { PureComponent } from 'react';
import { Input, Button } from 'semantic-ui-react';
import './search.css'

class Search extends PureComponent {
  render() {
    return (
      <div className="search-container">
        <Input
          className="search-input"
          placeholder="Find some interesting thigs to do!"
          actionPosition="right"
        >
          <input />
          <Button
            disabled={this.props.isSearching}
            loading={this.props.isSearching}
            as="action"
            onClick={this.props.onSearch}
          >
            Search
          </Button>
        </Input>
      </div>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/components/search/index.jsx